import OfferRoundel from './OfferRoundel'

export default OfferRoundel
